import React from 'react'

import { GridFooterContainer, GridPagination, GridSlotsComponentsProps } from '@mui/x-data-grid'
import { Tooltip } from 'react-tooltip'

import Button from '@mui/material/Button'
import { useAirdropState } from 'src/contexts/airDropContext'

export default function CustomFooter(props: NonNullable<GridSlotsComponentsProps['footer']>) {
  const authState = useAirdropState()

  return (
    <GridFooterContainer
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: props.isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
      <div className="flex" style={{ marginTop: '2rem' }}>
        {props.selectedTransactions?.length ? (
          <Button
            className="btn btn-warning"
            color="error"
            size="small"
            variant="contained"
            sx={{
              padding: '6px 16px !important',
            }}
            onClick={props.toggleRemoveModal}>
            Remove transactions
          </Button>
        ) : null}
        <div
          id="execute"
          style={{
            marginLeft: !props.selectedTransactions?.length || props.isMobile ? 0 : '2rem',
            marginBottom: props.isMobile ? '1rem' : 0,
          }}>
          <Button
            className="btn btn-success"
            color="success"
            size="small"
            variant="contained"
            sx={{
              padding: '6px 16px !important',
            }}
            disabled={!props.executableTransactions?.length || !authState.initiator}
            onClick={props.toggleExecuteModal}>
            Execute transactions
          </Button>
        </div>
        <Tooltip anchorSelect="#execute">
          <p>
            Make sure your have connected your wallet
            <br />
          </p>{' '}
          <p>and you have at least one "new" transaction selected</p>
        </Tooltip>

        {props.checkableTransactions?.length ? (
          <Button
            className="btn btn-primary"
            color="info"
            size="small"
            variant="contained"
            sx={{
              padding: '6px 16px !important',
              marginLeft: props.isMobile ? 0 : '2rem',
            }}
            onClick={props.onCheckTransactions}>
            Check pending
          </Button>
        ) : null}
      </div>
      <GridPagination />
    </GridFooterContainer>
  )
}
